"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowConditionRendererFactory = void 0;
const Palette_1 = require("@opsbase/lib-palette/Palette");
const OperatorType_1 = require("@opsbase/lib-workflow/WorkflowCondition/OperatorType");
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const startCase_1 = __importDefault(require("lodash/startCase"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    rpad: {
        paddingRight: 2,
    },
    lrpad: {
        paddingLeft: 2,
        paddingRight: 2,
    },
    lrpad2: {
        paddingLeft: 2,
        paddingRight: 4,
    },
    hlite: {
        color: Palette_1.Palette.secondary.dark,
        fontStyle: 'italic',
    },
});
const WorkflowConditionRendererFactory = (viewField) => (workflow) => {
    const conditions = workflow[viewField.propertyName];
    return (react_1.default.createElement(Vertical_1.default, { justify: 'flex-start', gutter: true }, conditions === null || conditions === void 0 ? void 0 : conditions.map((orCondition, i) => {
        var _a;
        return (react_1.default.createElement("div", { key: 'cond' + i },
            react_1.default.createElement("div", null, (_a = orCondition.andConditions) === null || _a === void 0 ? void 0 : _a.map((andCondition, j) => (react_1.default.createElement(AndCondition, { key: 'andCond' + j, condition: andCondition, idx: j, last: j < orCondition.andConditions.length - 1 })))),
            i < conditions.length - 1 && react_1.default.createElement("span", null, " or ")));
    })));
};
exports.WorkflowConditionRendererFactory = WorkflowConditionRendererFactory;
exports.default = exports.WorkflowConditionRendererFactory;
function AndCondition(props) {
    var _a, _b, _c, _d, _e;
    const { condition } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const fieldAndOperator = (0, startCase_1.default)((0, camelCase_1.default)(condition.queryFieldKey)) +
        ' ' +
        (condition.operator ? (0, OperatorType_1.operatorTypeLabel)(condition.operator) + ' ' : '');
    const from = (_b = (_a = condition.value) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.toString();
    const to = (_d = (_c = condition.value) === null || _c === void 0 ? void 0 : _c.to) === null || _d === void 0 ? void 0 : _d.toString();
    const title = (_e = condition.value) === null || _e === void 0 ? void 0 : _e.title;
    return (react_1.default.createElement("div", null,
        fieldAndOperator,
        !!from && react_1.default.createElement("span", { className: myCss.hlite }, from),
        !from && !!(title === null || title === void 0 ? void 0 : title.length) && (react_1.default.createElement("span", { className: myCss.hlite }, (title === null || title === void 0 ? void 0 : title[0]) + (title.length > 1 ? ' +' + (title.length - 1) : ''))),
        !!to && ' and ',
        !!to && react_1.default.createElement("span", { className: myCss.hlite }, to)));
}
